import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './index.scss';

class OptionPanel extends Component {
  static propTypes = {
    onSelect: PropTypes.func,
    index: PropTypes.number,
    selected: PropTypes.bool,
    icon: PropTypes.string,
  };

  onClick() {
    this.props.onSelect(this.props.index, this.props.id);
  }

  render() {
    return (
      <div
        className={`OptionPanel ${
          this.props.selected ? 'OptionPanel-Selected' : null
        }`}
        onClick={() => this.onClick()}
      >
        <span className="OptionPanel-Text">{this.props.children}</span>
      </div>
    );
  }
}

export default OptionPanel;
